const s = /(?:^|[-_])(\w)/g, i = (n) => n.replace(s, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function a(n, e) {
  if (n.$root === n)
    return "<Root>";
  const r = typeof n == "function" && n.cid != null ? n.options : n._isVue ? n.$options || n.constructor.options : n || {};
  let t = r.name || r._componentTag;
  const o = r.__file;
  if (!t && o) {
    const c = o.match(/([^/\\]+)\.vue$/);
    t = c && c[1];
  }
  return (t ? `<${i(t)}>` : "<Anonymous>") + (o && e !== !1 ? ` at ${o}` : "");
}
function u(n) {
  if (n._isVue && n.$parent) {
    const e = [];
    let r = 0;
    for (; n; ) {
      if (e.length > 0) {
        const t = e[e.length - 1];
        if (t.constructor === n.constructor) {
          r++, n = n.$parent;
          continue;
        } else r > 0 && (e[e.length - 1] = [t, r], r = 0);
      }
      e.push(n), n = n.$parent;
    }
    return `

found in

${e.map(
      (t, o) => `${o === 0 ? "---> " : " ".repeat(5 + o * 2)}${Array.isArray(t) ? `${a(t[0])}... (${t[1]} recursive calls)` : a(t)}`
    ).join(`
`)}`;
  }
  return `

(found in ${a(n)})`;
}
function l(n, e, r) {
  if (process.env.NODE_ENV !== "production") {
    if (e) {
      if (e.$_alreadyWarned = e.$_alreadyWarned || [], e.$_alreadyWarned.includes(n))
        return;
      e.$_alreadyWarned.push(n);
    }
    return `[Components] ${n}${e ? u(e) : ""}`;
  }
}
function p(n, e, r) {
  const t = l(n, e);
  t != null && console.warn(t);
}
export {
  p as warn
};
//# sourceMappingURL=console.js.map
